import { Chart, ChartOptions } from 'chart.js'

export const deviceCountCardChartLegendPlugin = {
  afterUpdate(chart: Chart, mode: any, options: ChartOptions<'pie'>) {
    const legendContainer = document.getElementById(options.containerID!)

    let legendContainerList = legendContainer?.querySelector('ul')

    if (!legendContainerList) {
      legendContainerList = document.createElement('ul')
      legendContainerList.setAttribute(
        'class',
        'DashboardDeviceCountCard-legend-container',
      )

      legendContainer?.appendChild(legendContainerList)
    }

    while (legendContainerList.firstChild) {
      legendContainerList.firstChild.remove()
    }

    if (
      typeof chart.options.plugins?.legend?.labels?.generateLabels !==
      'function'
    ) {
      return
    }

    const legendItems =
      chart.options.plugins.legend.labels.generateLabels(chart)

    legendItems.forEach((item, index) => {
      // Create legend item
      const legendItem = document.createElement('li')

      legendItem.setAttribute('class', 'DashboardDeviceCountCard-legend-item')

      legendItem.onclick = () => {
        chart.toggleDataVisibility(item.index!)

        chart.update(mode)
      }

      // Create color box
      const boxSpan = document.createElement('span')

      boxSpan.style.background = item.fillStyle?.toString() || ''
      boxSpan.setAttribute('class', 'DashboardDeviceCountCard-color-box')

      const nameContainer = document.createElement('p')

      nameContainer.style.textDecoration = item.hidden ? 'line-through' : ''
      nameContainer.setAttribute(
        'class',
        'DashboardDeviceCountCard-legend-name',
      )

      // Create name
      const name = document.createTextNode(`${item.text}:`)

      nameContainer.appendChild(name)

      const totalContainer = document.createElement('p')

      totalContainer.setAttribute(
        'class',
        'DashboardDeviceCountCard-legend-total',
      )

      // Create total
      const total = document.createTextNode(
        `${chart.data.datasets[0].data[index]}`,
      )

      totalContainer.appendChild(total)

      // Append values to legend item and then append legend item to legend
      legendItem.appendChild(boxSpan)
      legendItem.appendChild(nameContainer)
      legendItem.appendChild(totalContainer)
      legendContainerList?.appendChild(legendItem)
    })
  },
  id: 'htmlLegend',
}
